import { IStore } from '../../../common/store';

export const getVariantDetailsLoadingState = (state: IStore) =>
  state.customiseCombinedReducer.variantDetailsReducer.loading;
export const getVariantDetailsErrorState = (state: IStore) =>
  state.customiseCombinedReducer.variantDetailsReducer.error;
export const getVariantDetails = (state: IStore) => state.customiseCombinedReducer.variantDetailsReducer.variantDetails;
export const getVariantDetailsCars = (state: IStore) =>
  state.customiseCombinedReducer.variantDetailsReducer.variantDetails?.cars;
export const getVariantDetailsExteriors = (state: IStore) =>
  state.customiseCombinedReducer.variantDetailsReducer.variantDetails?.exteriorColours;
export const getVariantDetailsInteriors = (state: IStore) =>
  state.customiseCombinedReducer.variantDetailsReducer.variantDetails?.interiorColours;
export const getVariantMarketingCategory = (state: IStore) =>
  state.customiseCombinedReducer.reducer.variantDetailsReducer.marketingCategory;
